import CustomTabContainer from "../../../../components/CustomTabContainer";
import {CUSTOM_ACCESS_TABS, DEPARTMENT_TABS, TABS_FA} from "../Model/Model";
import CustomTab from "../../../../components/CustomTab";
import {AvailableTabsApp} from "../Funtionality/AvailableTabsApp";
import React from "react";
import TabPanel from "./TabPanel";
import {DepartmentTabApp} from "../Funtionality/DepartmentTabApp";
import {CustomAccessTabApp} from "../Funtionality/CustomAccessTabApp";


/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 29 de 04 de 2026
 */

/**
 * Component used to manage available assignment tabs
 * for employees and departments.
 *
 * This component handles:
 * - Tab navigation.
 * - Search synchronization.
 * - Dynamic tab rendering.
 * - Employee assignment flow.
 * - Department assignment flow.
 * - Delete trigger propagation.
 * - Shared tab state management.
 *
 * @component AvailableTabs
 *
 * @param {Object} props - Component properties.
 * @param {string} props.authentication - Authentication mode identifier.
 * @param {Function} props.setDeviceCustomAccess - Updates employee assignments.
 * @param {Function} props.setDeviceDepartment - Updates department assignments.
 * @param {number|string|undefined} props.id - Device identifier.
 * @param {Array<number|string>} props.selectForDeleteEmp - Selected employees for deletion.
 * @param {Function} props.setSelectForDeleteEmp - Updates selected employees for deletion.
 * @param {Array<number|string>} props.selectForDeleteDepa - Selected departments for deletion.
 * @param {Function} props.setSelectForDeleteDepa - Updates selected departments for deletion.
 *
 * @returns {JSX.Element} Available tabs component.
 */

const AvailableTabs = ({
                           authentication,
                           setDeviceCustomAccess,
                           setDeviceDepartment,
                           id,
                           selectForDeleteEmp,
                           setSelectForDeleteEmp,
                           selectForDeleteDepa,
                           setSelectForDeleteDepa,
}) => {

    const {
        t,
        subView,
        setSubView,
        setBodyForExport,
        searchElement,
        setSearchElement,
        setSimpleSearch,
        setSearch,
        modified,
        setModified,
        triggerDelete,
        setTriggerDelete
    } = AvailableTabsApp()

    return (
        <div className={"border-full-shades-200 col-12 border-radius-8px px-0"}>
            <CustomTabContainer
                activeTab={subView}
                setActiveTab={(e) => {
                    setSearchElement("");
                    setSubView(e);
                }}
                className="border-0 px-3"
                paddingClass=''
            >
                {Object.values(TABS_FA).map((item) => (
                    <CustomTab
                        key={item.key}
                        id={item.key}
                        title={t(item.translation)}
                        icon={item.icon}
                        selected={subView === item.key}
                        onClick={() => {
                            setSubView(item.key)
                        }}
                        className={'w-100'}
                    />
                ))}
            </CustomTabContainer>

            <div className="border-bottom-shades-300 mb-3" />

            { subView === TABS_FA.CUSTOM_ACCESS.key &&
                <TabPanel
                    setBodyForExport={setBodyForExport}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    setSearch={setSearch}
                    setSimpleSearch={setSimpleSearch}
                    modified={modified}
                    setModified={setModified}
                    tabsConfig={CUSTOM_ACCESS_TABS}
                    addKey="ADD_EMPLOYEES"
                    assignedKey="ASSIGNED_EMPLOYEES"
                    useTabApp={CustomAccessTabApp}
                    setDeviceList={setDeviceCustomAccess}
                    selectForDelete={selectForDeleteEmp}
                    setSelectForDelete={setSelectForDeleteEmp}
                    id={id}
                    authentication={authentication}
                    subView={subView}

                    triggerDelete={triggerDelete}
                    setTriggerDelete={setTriggerDelete}
                />
            }
            { subView === TABS_FA.DEPARTMENTS.key &&
                <TabPanel
                    setBodyForExport={setBodyForExport}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    setSearch={setSearch}
                    setSimpleSearch={setSimpleSearch}
                    modified={modified}
                    setModified={setModified}
                    tabsConfig={DEPARTMENT_TABS}
                    addKey="ADD_DEPARTMENT"
                    assignedKey="ASSIGNED_DEPARTMENT"
                    useTabApp={DepartmentTabApp}
                    setDeviceList={setDeviceDepartment}
                    selectForDelete={selectForDeleteDepa}
                    setSelectForDelete={setSelectForDeleteDepa}
                    authentication={authentication}
                    id={id}
                    subView={subView}

                    triggerDelete={triggerDelete}
                    setTriggerDelete={setTriggerDelete}
                />
            }
        </div>
    )
}

export default AvailableTabs
